import React from 'react';
export const CardHeader = ({ description, loading = false }) => {
    return (React.createElement(React.Fragment, null,
        loading && React.createElement("div", { className: "card-header" },
            React.createElement("div", { className: "block-header_title--loading" })),
        !loading && description && React.createElement("div", { className: "card-header" },
            React.createElement("p", null, description))));
};
//# sourceMappingURL=CardHeader.js.map